/**
 * Logger utility
 * - debug/info: Only logged in development (silenced in production)
 * - warn/error: Always logged (needed for error tracking)
 */
const isDev = import.meta.env.DEV;

// No-op function for silenced logs
const noop = () => {};

export const logger = {
  debug: isDev ? (...args: unknown[]) => console.debug(...args) : noop,
  info: isDev ? (...args: unknown[]) => console.info(...args) : noop,
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
};
